module.exports = __webpack_public_path__ + "img/finishTip.7f675b74.png";